import { Component, NgZone } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { Plan, User } from "@app/data/user";
import { environment } from "environments/environment";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Catalog } from "@app/data/catalog";
import { CatalogService } from "@services/catalog.service";
import {
  GlobalSettings,
  GlobalSettingsService,
} from "@app/services/global-settings.service";
import { CouponService } from "@app/services/coupon.service";
import * as _ from "lodash";
import { RemoteDataService } from "@nowinstore/nowinstore-core-ui/components";
import { STORE_API_URL } from "@app/data/const";

declare var gapi;

@Component({
  templateUrl: "./dashboard.component.html",
  animations: [],
})
export class DashboardComponent {
  startDate: string = "7daysAgo";
  endDate: string = "today";
  isTrial: boolean;
  plan: Plan;
  user: User;
  catalog: Catalog;
  hasAuthorization: boolean;
  hasSelectedView: boolean;
  // cards = [
  //   {
  //     title: "Total Catalog Views",
  //     queryChart: {
  //       ids: null,
  //       dimensions: "ga:date",
  //       metrics: "ga:totalEvents",
  //       filters: `ga:eventCategory==Catalog;ga:eventAction==View Catalog`,
  //     },
  //     query: {
  //       ids: null,
  //       metrics: "ga:totalEvents",
  //       dimensions: `ga:eventLabel`,
  //       filters: `ga:eventCategory==Catalog;ga:eventAction==View Catalog`,
  //       sort: "-ga:totalEvents",
  //       "max-results": 5,
  //     },
  //     report: null,
  //   },
  //   {
  //     title: "Total Pages Views",
  //     queryChart: {
  //       ids: null,
  //       dimensions: "ga:date",
  //       metrics: "ga:totalEvents",
  //       filters: `ga:eventCategory==Catalog;ga:eventAction==View Page`,
  //     },
  //     query: {
  //       ids: null,
  //       metrics: "ga:totalEvents",
  //       dimensions: `ga:eventLabel`,
  //       filters: `ga:eventCategory==Catalog;ga:eventAction==View Page`,
  //       sort: "-ga:totalEvents",
  //       "max-results": 5,
  //     },
  //     report: null,
  //   },
  // ];
  hasAccessToTearSheet: boolean = false;
  hasExpired: boolean = false;
  // isGA4: boolean;
  promotion: GlobalSettings;
  showCoupon: boolean;
  storeConnected: boolean = true;
  menuItems: any[] = [];
  accountType: string = "";

  constructor(
    private couponService: CouponService,
    private globalSettingsService: GlobalSettingsService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private remoteDataService: RemoteDataService,
    private zone: NgZone
  ) {
    this.userService.me().then(async (user) => {
      if (user.accounts[0].type === "woocommerce") {
        try {
          await this.remoteDataService.get(STORE_API_URL, "check-connection");
        } catch (error) {
          this.storeConnected = false;
        }
      }

      this.accountType = user.accounts?.[0]?.type || "";

      const subscriptions = _.find(user.subscriptions, { duration: null });
      if (subscriptions === undefined) {
        this.globalSettingsService.get("promotion").then((settings) => {
          this.promotion = settings;
          if (this.promotion) {
            this.couponService.query().then((coupons) => {
              const coupon = coupons
                ? coupons[this.promotion.parameters.coupon_code]
                : null;
              this.showCoupon = coupon && coupon.valid;
            });
          }
        });
      }
    });
    this.userService.hasAccess("tear-sheet").then((hasAccess) => {
      this.menuItems = [
        {
          label: $localize`Catalogs & Line Sheets`,
          description: $localize`Build interactive catalogs with integrated ordering for retail and wholesale`,
          icon: "/platform/assets/img/catalog-icon-dark.png",
          routerLink: "/catalogs/list",
          tags: ["printable", "digital", "retail", "wholesale"],
        },
        {
          label: $localize`Printable Order Sheet`,
          description: $localize`Create custom order forms tailored to your wholesale business`,
          icon: "/platform/assets/img/order-sheet-icon-dark.png",
          routerLink: "/order-sheet",
          tags: ["printable", "wholesale"],
        },
        {
          label: $localize`Digital Order Sheet`,
          description: $localize`Send digital order sheets to your wholesale customers`,
          icon: "/platform/assets/img/digital-order-sheet-icon-dark.png",
          routerLink: "/digital-order-sheet/configuration",
          tags: ["digital", "wholesale"],
        },
        {
          label: $localize`Tear Sheet`,
          description: $localize`Let your customers download products specifications directly from your store`,
          icon: "/platform/assets/img/tear-sheet-icon-dark.png",
          routerLink: "/tear-sheet",
          hide: !this.hasAccessToTearSheet,
          tags: ["printable", "digital", "retail", "wholesale"],
        },
        {
          label: $localize`Flipbooks`,
          description: $localize`Transform static PDFs into interactive digital catalogs`,
          icon: "/platform/assets/img/flipbook-icon-dark.png",
          routerLink: "/flipbook",
          tags: ["digital", "retail", "wholesale"],
        },
        {
          label: $localize`Barcode Label`,
          description: $localize`Streamline inventory management with barcoded labels`,
          icon: "/platform/assets/img/barcode-icon-dark.png",
          routerLink: "/barcode",
          tags: ["printable", "retail", "wholesale"],
        },
        {
          label: $localize`Inventory Tag`,
          description: $localize`Print custom QR code labels for smart inventory control`,
          icon: "/platform/assets/img/tag-icon-dark.png",
          routerLink: "/inventory-tag",
          tags: ["printable", "retail", "wholesale"],
        },
      ];
      this.hasAccessToTearSheet = hasAccess;
    });
  }

  ngOnInit(): void {}

  // ngAfterViewInit(): void {
  //   if (!this.isGA4) {
  //     this.cards[0].query.filters = this.cards[0].queryChart.filters =
  //       "ga:eventCategory==Catalog;ga:eventAction==View Catalog";
  //     this.cards[1].query.filters = this.cards[1].queryChart.filters =
  //       "ga:eventCategory==Catalog;ga:eventAction==View Page";
  //   }
  //   if (this.activatedRoute.snapshot.params.catalogId) {
  //     this.catalogService
  //       .getCatalog(this.activatedRoute.snapshot.params.catalogId)
  //       .then((catalog) => {
  //         this.catalog = catalog;
  //         if (!this.isGA4) {
  //           this.cards.forEach((card) => {
  //             card.query.filters += `;ga:eventLabel==${catalog._id}`;
  //             card.queryChart.filters += `;ga:eventLabel==${catalog._id}`;
  //           });
  //         }
  //       });
  //   }

  //   this.userService.me().then((user) => {
  //     this.user = user;
  //     this.isGA4 =
  //       this.user.settings.ga4_tracking_id &&
  //       this.user.settings.ga4_tracking_id.length > 0;
  //     this.plan = user.subscription.plan;
  //     this.isTrial = user.subscription.is_trial;
  //     console.log("plan", this.plan, this.plan.limits);
  //     if (this.user.ga_refresh_token && !this.isGA4) {
  //       this.userService.refreshToken().then((user) => {
  //         console.log("token refreshed");
  //         this.user = user;
  //         gapi.analytics.ready(() => {
  //           this.zone.run(() => {
  //             this.authorize();
  //             console.log("analytics ready");
  //             this.hasSelectedView = this.user.settings.ga_view;
  //             if (this.hasSelectedView) {
  //               this.cards.forEach((card) => {
  //                 card.query.ids = card.queryChart.ids =
  //                   this.user.settings.ga_view.ids;
  //               });
  //             }
  //           });
  //         });
  //       });
  //     }
  //   });
  // }

  // authorize() {
  //   gapi.analytics.auth.authorize({
  //     serverAuth: {
  //       access_token: this.user.ga_access_token,
  //     },
  //   });
  //   this.hasAuthorization = true;
  // }
}
